<template>
    <tr :class="['table-row', isHoverable && 'hoverable', hasAlternateBackground && 'alternate-background']">
        <slot />
    </tr>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "TableRow",
    props: {
        isHoverable: {
            type: Boolean,
            default: false,
        },
        hasAlternateBackground: {
            type: Boolean,
            default: true,
        },
    },
});
</script>

<style>
@import "@/style/data-tables.css";
</style>
